import { useEffect, useState, type ReactNode } from "react";
import MainHeader from "../HeadingSection/MainHeader";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import styles from "./Layout.module.css";

const DESKTOP = "(min-width: 1000px)";

const matchesDesktop = () => typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(DESKTOP).matches;

// Read synchronously on the first render, so the wrong menu never flashes. Only one of the menus is mounted,
// so HamburgerMenu and its test ids are in the DOM once.
const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(matchesDesktop);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const query = window.matchMedia(DESKTOP);
    const onChange = () => setIsDesktop(query.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return isDesktop;
};

// The footer goes after main, outside its padding, so it reaches the edges and sits at the bottom.
const Layout = ({ children, footer }: { children: ReactNode; footer?: ReactNode }) => {
  const isDesktop = useIsDesktop();

  return (
    <div className={styles.shell}>
      {isDesktop && <Sidebar />}
      <div className={styles.column}>
        {isDesktop ? <TopBar /> : <MainHeader />}
        <main className={styles.content}>
          <div className={styles.grid}>{children}</div>
        </main>
        {footer}
      </div>
    </div>
  );
};

export default Layout;
